import React, { FC } from "react";
import { Helmet } from "react-helmet";
import bangalore from "images/contact-us/bangalore.png"
import facebook from "images/contact-us/facebook (1).png"
import insta from "images/contact-us/instagram.png"
import youtube from "images/contact-us/youtube.png"
import Logo from "shared/Logo/Logo";
import PageEnquiryy from "containers/PageHome/PageEnquiryy";
import SocialsList from "shared/SocialsList/SocialsList";










export interface PageContactProps {
  className?: string;
}

const info = [
  {
    title: "🗺 ADDRESS",
    desc: "Photo booth tattooed prism, portland taiyaki hoodie neutra typewriter",
  },
  {
    title: "💌 EMAIL",
    desc: "nc.example@example.com",
  },
  {
    title: "☎ PHONE",
    desc: "000-123-456-7890",
  },
];




const PageContact: FC<PageContactProps> = ({ className = "" }) => {



  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
    <Helmet>
        <title>
         Contact Us - Travel 
        </title>
        <meta
          name="description"
          content="We offer services including world tour packages, custom itineraries, expert guides, and hassle-free bookings. Explore the world with confidence and ease."
        />
        <meta
          name="keywords"
          content="Tour packages, Best tour packages, Best tour packages company, Travel Company in Bangalore, Visa Packages"
        />
      </Helmet>

      <div className=" font mb-12 lg:mb-10 bg-[#fbf7fb] p-16 ">

        <h2 className="font flex items-center text-3xl leading-[115%] md:text-3xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Contact Us
        </h2>
        {/*<h2 className="font flex items-center pt-4 text-3xl leading-[115%] md:text-lg md:leading-[115%] font-semibold text-sky-600 dark:text-neutral-100 justify-center">
          Managing Director : <span className="text-neutral-900">+91 96326 94971 </span>
        </h2>
        <h2 className="font flex items-center pt-2 text-3xl leading-[115%] md:text-lg md:leading-[115%] font-semibold text-sky-600 dark:text-neutral-100 justify-center">
          Director : <span className="text-neutral-900">+91 96326 94971 </span>
        </h2>
        {/* <div className="flex items center justify-center pt-2 mb-2">
           <img src={phonecall} className="mr-3 w-5 h-5 border-1 bg-gray-500 rounded-full " /> 
          <i className="las la-phone text-3xl pt-1"></i>
          <span className="font flex  items-center text-2xl pl-2 md:text-2xl  font-normal text-neutral-900 dark:text-neutral-100 justify-center">
            1800 22 7979</span>
        </div>
        <div className=" font flex items center justify-center">
          {/* <img src={email} className="mr-3 w-5 h-5" /> 
          <i className="las la-envelope text-3xl pt-1"></i>
          <span className="font flex text-2xl pl-2 md:text-2xl font-normal text-neutral-900 dark:text-neutral-100 justify-center" >
            travel@travel.com</span>
        </div>*/}
      </div>
      <div className=" container">
        <div className="w-full pb-4 pb-10 flex flex-wrap justify-center mx-auto">

          <div className="lg:w-4/12 w-full xl:pl-6 xl:py-0 py-2 lg:py-0 lg:w-4/12 w-full xl:px-0 lg:px-2">
            <div className="border shadow-xl rounded-xl ">
              <div className="flex items-center justify-between mb-6 font bg-[#fbf7fb] p-4 text-center rounded-t-xl ">
                <h2 className="font text-lg font-semibold ">Bengaluru</h2>
                <a href="" target="_blank">
                  <div className="text-blue-800 text-xs flex items-center ">
                    <i className="las la-map-pin text-xl font-bold"></i>
                    <p className="">Get Directions</p>
                  </div>
                </a>
              </div>

              <div className=" px-4 mb-4 ">
                <div className="flex mb-3">
                  <i className="las la-building text-2xl text-sky-700"></i>
                  <span className="font text-sm font-medium pl-2">HSR Layout, 27th main Road <br></br> Bengaluru, Karnataka - 560 003</span>
                </div>
                <div className="flex mb-3">
                  <i className="las la-phone-square text-2xl text-sky-700"></i>
                  <span className="font text-sm font-medium pl-2"><a href="tel:+919876543210">+91 9876543210</a></span>
                </div>
                <div className="flex lg:pb-3">
                  <i className="las la-envelope text-2xl text-sky-700"></i>
                  <span className="font text-sm font-medium pl-2"><a href="mailto:travel@travel.com">travel@travel.com</a></span>
                </div>

                <div className="border-t mt-5" />
                <div className="flex items-center justify-between mt-2">
                  <div className="text-sm font font-semibold text-sky-600 mt-2">
                    <p className="">
                      Working Hours
                    </p>
                    <p className="text-xs text-black ">
                      10:00 AM - 07:00 PM
                    </p>
                  </div>
                  {/*<Logo className="w-24" />*/}
                </div>
              </div>
            </div>
            {/*} <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.621335201645!2d77.58304527485366!3d12.932041887379691!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15c4b6a47ee9%3A0xdcb494a827ecb263!2sTrawel%20Mart%20World%20Tours%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1686833710089!5m2!1sen!2sin" width="590" height="450" className="border-1 w-600 h-450"  ></iframe>
         */} </div>







          
        </div>


        <div className="p-2 rounded-lg xl:bg-neutral-50 xl:mt-16 p-6">
          <h2 className="font flex items-center text-xl text-center leading-[115%] md:text-2xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Travel Has Established Its Travel Expertise In
          </h2>
          <div className="flex flex-wrap justify-center items-center mt-6 ">
            <div className="bg-gray-100 px-6 py-2  mx-2 text-center">
              <div className="flex justify-center ">
                <img src={bangalore} className="w-14 h-14 " />
              </div>
              <p className="text-xs font font-semibold mt-1">Bengaluru</p>
            </div>
            {/*<div className="bg-gray-100 px-6 py-2  mx-2 xl:my-0 my-2 text-center">
              <div className="flex justify-center ">
                <img src={mumbai} className="w-14 h-14 " />
              </div>
              <p className="text-xs font font-semibold mt-1">Mumbai</p>
            </div>
             {/*<div className="bg-gray-100 px-6 py-2  mx-2 text-center">
              <div className="flex justify-center ">
                <img src={bangalore} className="w-14 h-14 " />
              </div>
              <p className="text-xs font font-semibold mt-1">Kolkata</p>
            </div>
            {/* <div className="bg-gray-100 px-6 py-2  mx-2 text-center">
             <div className="flex justify-center ">
                <img src={mumbai} className="w-14 h-14 " />
              </div>
              <p className="text-xs font font-semibold mt-1">Pune</p>
        </div>*/}
            <div className="bg-gray-100 px-6 py-2  mx-2 xl:my-0 my-2 text-center">
              <div className="flex justify-center ">
                <img src={bangalore} className="w-14 h-14 " />
              </div>
              <p className="text-xs font font-semibold mt-1">Chennai</p>
            </div>
          </div>
          {/*<h2 className="mt-6 flex items-center text-lg leading-[115%] md:text-lg md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
            +50 more cities..
        </h2>*/}
        </div>
        <hr className="my-4" />


        <section className="xl:pt-6 xl:pb-12 pt-6 pb-12 ">
          <div className="grid xl:grid-cols-4 xl:gap-2 sm:grid-cols-2 sm:gap-2">
            <div className="xl:py-0 py-2">
              <div className="flex items-center">
                <i className="las la-building text-sky-600 xl:text-2xl"></i>
                <h2 className="font-semibold font xl:text-base pl-2">
                  Our Offices
                </h2>
              </div>
              <p className="xl:text-sm font xl:pt-1 pt-1">
                Located across the country, ready to assist in planning & booking your perfect vacation.
              </p>
              {/* <div className="flex xl:pt-2 pt-2">
                <a href="https://www.facebook.com/Traveldotcom/">
                  <img src={facebook} className="w-6 h-6  mr-3" />
                </a>
                <a href="https://www.facebook.com/Traveldotcom/">
                  <img src={insta} className="w-6 h-6 mr-3" />
                </a>
                <a href="https://www.facebook.com/Traveldotcom/">
                  <img src={youtube} className="w-6 h-6 mr-3" />
                </a>
              </div> */}
            </div>
            <div className="xl:py-0 py-3">
              <div className="flex items-center">
                <i className="las la-phone text-sky-600 xl:text-2xl"></i>
                <h2 className="font-semibold font xl:text-base pl-2">
                  Call Us
                </h2>
              </div>
              <p className="xl:text-sm font xl:pt-1">
                Request a quote, or just chat about your next vacation. We're always happy to help!
              </p>
              <div className="text-sky-600 font font-semibold xl:pt-2 xl:text-base">
                <a href="tel:9876543210">9876543210</a>
              </div>
            </div>
            <div className="xl:py-0 py-2">
              <div className="flex items-center">
                <i className="las la-edit text-sky-600 xl:text-2xl"></i>
                <h2 className="font-semibold font xl:text-base pl-2">
                  Write to Us
                </h2>
              </div>
              <p className="xl:text-sm font xl:pt-1 pt-1">
                Be it an enquiry, feedback or a simple <br></br>suggestion, write to us.
              </p>
              <div className="text-sky-600 font font-semibold xl:pt-2 pt-2 xl:text-base">
                <a href="mailto:enquiry@travel.com ">enquiry@travel.com </a>
              </div>
            </div>
            <div className="xl:py-0 py-2">
              <div className="flex items-center">
                <i className="las la-share text-sky-600 xl:text-2xl"></i>
                <h2 className="font-semibold font xl:text-base pl-2">
                  Connect with Us
                </h2>
              </div>
              <p className="xl:text-sm font xl:pt-1 pt-1">
                Check out reviews, podcasts, <br></br>blogs and more...
              </p>

              <SocialsList
                className="w-full !space-x-2 pt-2 lg:pt-4 text-right"
                itemClass="flex items-center justify-center w-8 h-8 rounded-lg bg-sky-100 text-black font-normal dark:bg-neutral-800 text-base"
              />
              {/* <div className="flex xl:pt-2 pt-2">
                <img src={facebook} className="w-6 h-6  mr-3" />
                <img src={insta} className="w-6 h-6 mr-3" />
                <img src={youtube} className="w-6 h-6 mr-3" /> */}
              {/*<img src={link} className="w-6 h-6 mr-3" />*/}
              {/* </div> */}
              {/* <div className="flex xl:pt-2 pt-2">
                <a href="https://www.facebook.com/Traveldotcom/">
                  <img src={facebook} className="w-6 h-6  mr-3" />
                </a>
                <a href="https://www.facebook.com/Traveldotcom/">
                  <img src={insta} className="w-6 h-6 mr-3" />
                </a>
                <a href="https://www.facebook.com/Traveldotcom/">
                  <img src={youtube} className="w-6 h-6 mr-3" />
                </a>
              </div> */}
            </div>
          </div>
        </section>
      </div>

      <PageEnquiryy />
    </div>
  );
};

export default PageContact;
